var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80859 0.665039H4.53027C4.80832 0.662373 5.07755 0.760794 5.28809 0.941406C5.49857 1.12206 5.63592 1.37274 5.6748 1.64648C5.79614 2.56133 6.02053 3.45963 6.34375 4.32422L6.34473 4.32617C6.42156 4.53017 6.43804 4.75176 6.39258 4.96484C6.34725 5.17698 6.24243 5.37246 6.08984 5.52734L4.94043 6.67383C4.72824 6.8856 4.68462 7.21314 4.83301 7.47363C6.18069 9.83905 8.14291 11.7977 10.5127 13.1426C10.7726 13.2899 11.099 13.2462 11.3105 13.0352L12.457 11.8906C12.6126 11.7371 12.8091 11.6306 13.0234 11.585C13.2377 11.5393 13.461 11.5559 13.666 11.6328L13.668 11.6338C14.5339 11.9562 15.4334 12.1797 16.3496 12.3008V12.3018C16.6281 12.341 16.883 12.4806 17.0645 12.6943C17.2457 12.908 17.3419 13.1806 17.335 13.46C17.3348 13.4655 17.334 13.4711 17.334 13.4766V16.1885C17.3346 16.3472 17.302 16.5048 17.2383 16.6504C17.1745 16.7959 17.0813 16.9267 16.9639 17.0342C16.8465 17.1417 16.7077 17.2234 16.5566 17.2744C16.4055 17.3254 16.2449 17.3444 16.0859 17.3301H16.085C13.408 17.0377 10.8366 16.1235 8.57715 14.6611L8.57227 14.6582L8.18164 14.4023C6.24686 13.0994 4.60016 11.412 3.34668 9.44336L3.34375 9.43848L3.07422 9.00879C1.76013 6.84746 0.937667 4.4221 0.668945 1.9043C0.655499 1.74827 0.674497 1.59088 0.724609 1.44238C0.775252 1.29239 0.856807 1.15416 0.963867 1.03711C1.07087 0.920171 1.20135 0.826805 1.34668 0.762695C1.45592 0.714537 1.57208 0.683288 1.69043 0.670898L1.80859 0.665039Z",
    fill: "#4A81E6",
    stroke: "#4A81E6",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFilled);
export default __webpack_public_path__ + "static/media/call_filled.5fe7d35e1df1cff8eeefcf218a341564.svg";
export { ForwardRef as ReactComponent };